module.exports = __webpack_public_path__ + "onboarding1.png";